<template>
  <div>
    <div class="box" id="box" ref="box">
      <h1>漏洞通报情况</h1>
      <vue-seamless-scroll :data="bug" class="warp" :class-option="classOption">
      <ul>
        <li v-for="item in bug">
          <span class="date">{{item.date}}</span>

          <div class="name-box" v-if="item.is_fixed == 'yes'">
            <el-tooltip class="item" effect="dark" :content="item.ent" placement="top-start">
              <span class="name" >{{item.ent}}</span>
            </el-tooltip>
          </div>

         <div class="fixed-box" v-if="item.is_fixed == 'no'">
           <el-tooltip class="item" effect="dark" :content="item.ent" placement="top-start">
             <span class="name" >{{item.ent}}</span>
           </el-tooltip>
         </div>

          <div class="province-box">
            <el-tooltip class="item" effect="dark" :content="getChineseName(item.geo)" placement="top-start">
              <span class="province">{{getChineseName(item.geo)}}</span>
            </el-tooltip>
          </div>

          <span class="num">{{item.num}}个</span>
          <div class="notice" v-if="item.is_disc == 'yes'">已通报</div>
          <div class="fix" v-if="item.is_disc == 'no'">未通报</div>
          <div class="notice" v-if="item.is_fixed == 'yes'">已修复</div>
          <div class="fix" v-if="item.is_fixed == 'no'">未修复</div>
        </li>
      </ul>
      </vue-seamless-scroll>
    </div>
  </div>
</template>
<script>
import {getVulnerabilityNotification} from "@/service/dashboard";
import vueSeamlessScroll from "vue-seamless-scroll";
import {countryChineseDict, countryDict} from "@/theme/dict";
export default {
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      bug:[
        {date:"5-19",ent:"xx单位",geo:"北京市", num:"1",is_disc:"1",is_fixed:"0"},
        {date:"5-17",ent:"xx单位",geo:"北京市", num:"1",is_disc:"1",is_fixed:"0"},
        {date:"5-16",ent:"xx单位",geo:"北京市", num:"1",is_disc:"1",is_fixed:"0"},
        {date:"5-15",ent:"xx单位",geo:"北京市", num:"1",is_disc:"1",is_fixed:"1"},
        {date:"5-13",ent:"xx单位",geo:"北京市", num:"1",is_disc:"1",is_fixed:"1"},
        {date:"5-11",ent:"xx单位",geo:"北京市", num:"1",is_disc:"1",is_fixed:"0"},
        {date:"5-8",ent:"xx单位",geo:"北京市", num:"1",is_disc:"1",is_fixed:"0"},
        {date:"5-2",ent:"xx单位",geo:"北京市", num:"1",is_disc:"1",is_fixed:"0"}
      ],
      classOption: {
        step:1,
        singleHeight:0.25 ,
        waitTime: 3000,
        isSingleRemUnit: true

      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getMirrorName(obj,name) {
      const result = Object.entries(obj).find(([key, val]) => val === name);

      return result ? result[0] : null;
    },
    getChineseName(shortName) {
      const foreignFullName = countryDict[shortName];
      const chineseName = countryChineseDict[foreignFullName];

      return chineseName;
    },
    getData(){
      getVulnerabilityNotification().then(res => {
        // 遍历原始数据数组
        res.forEach(item => {
          // 提取月和日部分，并格式化为 "MM-DD"
          let formattedDate = item.date.substring(5, 10);

          let newArray = res.map( item => ({
            date:formattedDate,
            ent: item.ent,
            geo:item.geo,
            num:item.num,
            is_disc:item.is_disc,
            is_fixed:item.is_fixed
          }));

          this.bug = newArray;
          // console.log(newArray)
        });
      });
    }
  }
};


</script>
<style scoped lang="less">
.box {
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  width: 430px;
  height: 441px;
  border-radius: 10px;
  padding-top: 10px;
  padding-left: 35px;
  box-sizing: border-box;
}
h1{
  color: rgba(241, 237, 255, 1);
  font-family: 'YouSheBiaoTiHei';
  font-size: 24px;
  height: 31px;
  text-align: left;
  text-shadow: 0 2px 20px rgba(42, 56, 180, 1) ;
  margin-bottom: 10px;
}
.warp{
  overflow: hidden;
  height: 376px;
}
ul li{
  font-family: AlibabaRegular;
  list-style-type: none; /* 去除项目符号 */
  width: 381px;
  height: 48px;
  line-height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:0 15px;
  box-sizing: border-box;
  color: #fff;
}
li span{
  margin-right:10px;
}
li:nth-of-type(odd){
  background: url("../../assets/PlatformOverview/textBackground.png") no-repeat;
  background-size: 100%;
}
li .date{
  width: 50px;
}
li .num{
  width: 50px;
}
li .province-box{
  min-width: 32px;
  text-align: left;
  width: 50px;
  white-space: nowrap; /* 确保文本在一行内显示 */
  overflow: hidden; /* 隐藏超出容器的内容 */
  text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
}

.right {
  text-align: center;
}
li .name-box{
  text-align: left;
  width: 50px;
  color: rgba(159, 158, 242, 1);
  white-space: nowrap; /* 确保文本在一行内显示 */
  overflow: hidden; /* 隐藏超出容器的内容 */
  text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
}

li .fixed-box{
  text-align: left;
  width: 50px;
  color: rgba(244, 191, 54, 1);
  white-space: nowrap; /* 确保文本在一行内显示 */
  overflow: hidden; /* 隐藏超出容器的内容 */
  text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
}
li .notice{
  width: 57px;
  height: 21px;
  color: #fff;
  font-size: 12px;
  border-radius: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to right, rgba(92, 91, 140, 1),rgba(111, 120, 200, 1));
}
li .fix{
  width: 57px;
  height: 21px;
  color: #fff;
  font-size: 12px;
  border-radius: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to right, rgba(182, 109, 0, 1),rgba(255, 161, 57, 1));
}
</style>